"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _hooks = require("../../hooks");

var Button = function Button(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["className", "classNames"]);

  var variant = restProps.variant,
      size = restProps.size,
      color = restProps.color,
      type = restProps.type,
      iconBefore = restProps.iconBefore,
      iconAfter = restProps.iconAfter,
      linkTo = restProps.linkTo,
      externalLinkTo = restProps.externalLinkTo,
      text = restProps.text,
      children = restProps.children,
      disabled = restProps.disabled,
      other = (0, _objectWithoutPropertiesLoose2.default)(restProps, ["variant", "size", "color", "type", "iconBefore", "iconAfter", "linkTo", "externalLinkTo", "text", "children", "disabled"]);
  var content = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, iconBefore && /*#__PURE__*/_react.default.createElement("i", {
      className: iconBefore
    }), text && /*#__PURE__*/_react.default.createElement("span", null, text) || children, iconAfter && /*#__PURE__*/_react.default.createElement("i", {
      className: iconAfter
    }));
  }, [iconBefore, text, iconAfter, children]);
  var classes = (0, _react.useMemo)(function () {
    return (classNames([{
      color: color,
      variant: variant
    }, {
      size: size
    }, {
      disabled: disabled
    }]) + " " + className).trim();
  }, [classNames, className, color, variant, size, disabled]);

  if (linkTo) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
      to: linkTo,
      className: classes
    }, other), content);
  } else if (externalLinkTo) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      href: externalLinkTo,
      className: classes
    }, other), content);
  }

  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: classes,
    type: type,
    disabled: disabled
  }, other), content);
};

Button.propTypes = {
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** A character/s to concatenate modifier classNames. It will be used to generate the component modifier className. */
  modifierChar: _propTypes.default.string,

  /**
   * It specifies the design variant. It will be used as a modifier to generate the component className.
   - __fill__ Buttons are high-emphasis, distinguished by their use of elevation and fill. They contain actions that are primary to your app.
   - __outline__ Buttons are medium-emphasis buttons. They contain actions that are important but aren’t the primary action in an app.
   - __clear__ Buttons are typically used for less-pronounced actions. */
  variant: _propTypes.default.oneOfType([_propTypes.default.oneOf(['fill', 'outline', 'clear']), _propTypes.default.string]),

  /** It specifies the size. It will be used as a modifier to generate the component className. */
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['s', 'm', 'l']), _propTypes.default.string]),

  /** It specifies the color scheme. It will be used as a modifier to generate the component className. */
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'success', 'warning', 'danger', 'black', 'white']), _propTypes.default.string]),

  /** It extends component styles. */
  className: _propTypes.default.string,

  /** It specifies the Button type. */
  type: _propTypes.default.oneOf(['button', 'submit', 'input']),

  /** If defined, an icon element will be rendered before the Button content. Used icon has to be declared as a className. */
  iconBefore: _propTypes.default.string,

  /** If defined, an icon element will be rendered after the Button content. Used icon has to be declared as a className. */
  iconAfter: _propTypes.default.string,

  /** The path to link to when the Button is clicked. If defined, a 'Link' element will be used as the root node. */
  linkTo: _propTypes.default.string,

  /** Specifies the external link's destination:. If defined, an 'a' with 'href' element will be used as the root node. */
  externalLinkTo: _propTypes.default.string,

  /** The text of the Button. If defined, the 'children' prop will be ignored */
  text: _propTypes.default.string,

  /** The content of the Button. */
  children: _propTypes.default.node,

  /** It specifies Button is disabled. If it is defined in a Button with 'LinkTo' prop, it will return a 'disabled' modifier className else it will return 'disabled' attribute. */
  disabled: _propTypes.default.bool
};
Button.defaultProps = {
  alias: 'Btn',
  modifierChar: '___',
  variant: 'fill',
  size: 'l',
  color: 'primary',
  className: '',
  type: 'button',
  disabled: false
};
Button.displayName = 'Button';
var _default = Button;
exports.default = _default;